<div mat-dialog-title>
  <div class="row align-items-start justify-content-center">
    <span class="text-muted"> {{ dialogTitle }}</span>
  </div>
</div>

<mat-dialog-content>
  <image-cropper
    [imageChangedEvent]="imageChangedEvent"
    [maintainAspectRatio]="true"
    [aspectRatio]="aspectRatio"
    [resizeToWidth]="resizeToWidth"
    [onlyScaleDown]="true"
    format="webp"
    (imageCropped)="imageCropped($event)"
  ></image-cropper>
</mat-dialog-content>

<mat-dialog-actions class="row align-items-start justify-content-center">
  <div class="col-auto">
    <button
      class="mb-3 button-outline-primary"
      mat-stroked-button
      color="default"
      (click)="close()"
    >
      CANCELAR
    </button>
    <button
      class="mb-3 button-raised-primary text-white"
      mat-raised-button
      color="accent"
      (click)="save()"
    >
      CONFIRMAR
    </button>
  </div>
</mat-dialog-actions>
